import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FileUploadModule } from "ng2-file-upload";
import { AngularMaterialModule } from "./modules/angular-material.module";
import { PrimeNgModule } from "./modules/prime-ng.module";
import { DialogService } from "./services/dialog.service";
//import { NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu';
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
//components
import { AlertBoxComponent } from "./components/alert-box/alert-box.component";
import { AlertComponent } from "./components/alert/alert.component";
import { ButtonBuscarComponent } from "./components/buttons/button-buscar/button-buscar.component";
import { ButtonCancelarComponent } from "./components/buttons/button-cancelar/button-cancelar.component";
import { ButtonExpandableComponent } from "./components/buttons/button-expandable/button-expandable.component";
import { ButtonExportarComponent } from "./components/buttons/button-exportar/button-exportar.component";
import { ButtonGuardarComponent } from "./components/buttons/button-guardar/button-guardar.component";
import { ButtonLimpiarComponent } from "./components/buttons/button-limpiar/button-limpiar.component";
import { ButtonListGuardarComponent } from "./components/buttons/button-list-guardar/button-list-guardar.component";
import { ButtonListComponent } from "./components/buttons/button-list/button-list.component";
import { ButtonNuevoComponent } from "./components/buttons/button-nuevo/button-nuevo.component";
import { BaseButtonComponent } from "./components/buttons/button/base-button.component";
import { FormFieldComponent } from "./components/form-controls/form-field/form-field.component";
import { FormModelFieldComponent } from "./components/form-controls/form-model-field/form-model-field.component";
import { DataGridEditableComponent } from "./components/grids/data-grid-editable/data-grid-editable.component";
import { DataGridFormFilterComponent } from "./components/grids/data-grid-form-filter/data-grid-form-filter.component";
import { DataGridV2BodyColumnComponent } from "./components/grids/data-grid-v2/data-grid-v2-body-column/data-grid-v2-body-column.component";
import { DataGridV2HeadColumnComponent } from "./components/grids/data-grid-v2/data-grid-v2-head-column/data-grid-v2-head-column.component";
import { DataGridV2Component } from "./components/grids/data-grid-v2/data-grid-v2.component";
import { DataGridBodyColumnComponent } from "./components/grids/data-grid/data-grid-body-column/data-grid-body-column.component";
import { DataGridButtonsEditableComponent } from "./components/grids/data-grid/data-grid-buttons-editable/data-grid-buttons-editable.component";
import { DataGridButtonsComponent } from "./components/grids/data-grid/data-grid-buttons/data-grid-buttons.component";
import { DataGridPaginatorComponent } from "./components/grids/data-grid/data-grid-paginator/data-grid-paginator.component";
import { DataGridSkeletonComponent } from "./components/grids/data-grid/data-grid-skeleton/data-grid-skeleton.component";
import { DataGridComponent } from "./components/grids/data-grid/data-grid.component";
import { ListGridComponent } from "./components/grids/list-grid/list-grid.component";
import { HeaderComponent } from "./components/layout/header/header.component";
import { LayoutComponent } from "./components/layout/layout/layout.component";
import { NgMaterialMultilevelMenuModule } from "./components/layout/lib/ng-material-multilevel-menu.module";
import { PageTitleComponent } from "./components/layout/page-title/page-title.component";
import { SidenavComponent } from "./components/layout/sidenav/sidenav.component";
import { TopProgressbarComponent } from "./components/layout/top-progressbar/top-progressbar.component";
import { TreePickerActionButtonsComponent } from "./components/lists/tree-picker/tree-picker-action-buttons/tree-picker-action-buttons.component";
import { TreePickerItemExpandableComponent } from "./components/lists/tree-picker/tree-picker-item-expandable/tree-picker-item-expandable.component";
import { TreePickerItemSimpleComponent } from "./components/lists/tree-picker/tree-picker-item-simple/tree-picker-item-simple.component";
import { TreePickerSingleComponent } from "./components/lists/tree-picker/tree-picker-single/tree-picker-single.component";
import { TreePickerComponent } from "./components/lists/tree-picker/tree-picker.component";
import { LoaderBlockUiComponent } from "./components/loaders/loader-block-ui/loader-block-ui.component";
import { LoaderConfigurationComponent } from "./components/loaders/loader-configuration/loader-configuration.component";
import { ContainerRightItemsComponent } from "./components/misc/container-right-items/container-right-items.component";
import { ImgOptionLinkComponent } from "./components/misc/img-option-link/img-option-link.component";
import { ModalContainerComponent } from "./components/modals/modal-container/modal-container.component";
import { ModalFormContainerComponent } from "./components/modals/modal-form-container/modal-form-container.component";
import { ModalMsgErrorsComponent } from "./components/modals/modal-form-container/modal-msg-errors/modal-msg-errors.component";
import { SignalIconComponent } from "./components/signal-icon/signal-icon.component";
import { SimpleSkeletonComponent } from "./components/simple-skeleton/simple-skeleton.component";
import { DragDropSingleUploaderComponent } from "./components/uploader/drag-drop-single-uploader/drag-drop-single-uploader.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
//import { ContainerOptionLinkComponent } from './components/misc/container-option-link/container-option-link.component';
// directives
import { DisableControlDirective } from "./directives/disabled-control.directive";
import { NgSelectFormFieldControlDirective } from "./directives/ng-select.directive";
import { NumberOnlyDirective } from "./directives/number-only.directive";
import { SiuTemplateDirective } from "./directives/siu-template.directive";

import { AlphanumericDirective } from "./directives/alpha-numeric.directive";
import { CustomAlphaNumericDirective } from "./directives/custom-alpha-numeric.directive";
import { CustomNumericAlphaDirective } from "./directives/custom-numeric-alpha.directive";
import { CustomNumericDirective } from "./directives/custom-numeric.directive";
import { DragDropDirective } from "./directives/drag-drop.directive";

// pipes
import { MatFormFieldModule, MatStepperModule } from "@angular/material";
import { QRCodeModule } from "angularx-qrcode";
import { NgxSpinnerModule } from "ngx-spinner";
import { ButtonSelectComponent } from "./components/buttons/button-select/button-select.component";
import { BandejaGridBodyColumnComponent } from "./components/grids/bandeja-list-grid/bandeja-grid-body-column/bandeja-grid-body-column.component";
import { BandejaListGridComponent } from "./components/grids/bandeja-list-grid/bandeja-list-grid.component";
import { UploadArchivoComponent } from "./components/upload-archivo/upload-archivo.component";
import { UploadArchivoZipComponent } from "./components/upload-archivozip/upload-archivozip.component";
import { UploadFileComponent } from "./components/upload-file/upload-file.component";
import { ZippyComponent } from "./components/zippy/zippy.component";
import { CustomEmailDirective } from "./directives/custom-email.directive";
import { ValidValueDirective } from "./directives/valid-value.directive";
import { BytesFormatPipe } from "./pipes/bytes-format.pipe";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { TextLimitPipe } from "./pipes/text-limit.pipe";
import { StatusCargaMasivaService } from "./services/status-carga-masiva.service";

import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  declarations: [
    // components
    HeaderComponent,
    LayoutComponent,
    SidenavComponent,
    DataGridComponent,
    DataGridPaginatorComponent,
    DataGridSkeletonComponent,
    SimpleSkeletonComponent,
    FormFieldComponent,
    BaseButtonComponent,
    DataGridButtonsComponent,
    ButtonListComponent,
    ButtonListGuardarComponent,
    ButtonBuscarComponent,
    ButtonLimpiarComponent,
    ButtonNuevoComponent,
    ButtonCancelarComponent,
    ButtonGuardarComponent,
    ButtonSelectComponent,
    DataGridEditableComponent,
    BandejaGridBodyColumnComponent,
    AlertComponent,
    ZippyComponent,
    ModalContainerComponent,
    ModalFormContainerComponent,
    ModalMsgErrorsComponent,
    DataGridFormFilterComponent,
    TreePickerComponent,
    TreePickerItemExpandableComponent,
    TreePickerItemSimpleComponent,
    TreePickerActionButtonsComponent,
    TreePickerSingleComponent,
    PageTitleComponent,
    TopProgressbarComponent,
    DragDropSingleUploaderComponent,
    LoaderConfigurationComponent,
    SignalIconComponent,
    ListGridComponent,
    BandejaListGridComponent,
    UserProfileComponent,
    LoaderBlockUiComponent,
    ButtonExportarComponent,
    AlertBoxComponent,
    ImgOptionLinkComponent,
    ContainerRightItemsComponent,
    DataGridBodyColumnComponent,
    DataGridV2Component,
    DataGridV2BodyColumnComponent,
    DataGridButtonsEditableComponent,
    DataGridV2HeadColumnComponent,
    FormModelFieldComponent,
    ButtonExpandableComponent,
    UploadFileComponent,
    // ContainerOptionLinkComponent,
    // directives
    SiuTemplateDirective,
    NgSelectFormFieldControlDirective,
    DisableControlDirective,
    NumberOnlyDirective,
    DragDropDirective,
    AlphanumericDirective,
    CustomAlphaNumericDirective,
    CustomNumericDirective,
    CustomNumericAlphaDirective,
    CustomEmailDirective,
    // pipes
    DateFormatPipe,
    BytesFormatPipe,
    TextLimitPipe,
    ValidValueDirective,
    UploadArchivoComponent,
    UploadArchivoZipComponent,
  ],
  imports: [
    AngularMaterialModule,
    RouterModule,
    FileUploadModule,
    // NgMaterialMultilevelMenuModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    CommonModule,
    NgSelectModule,
    NgMaterialMultilevelMenuModule,
    MatStepperModule,
    MatFormFieldModule,
    QRCodeModule,
    NgxSpinnerModule,
    TextMaskModule
  ],
  exports: [
    AngularMaterialModule,
    PrimeNgModule,
    NgSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    MatStepperModule,
    MatFormFieldModule,
    QRCodeModule,
    NgxSpinnerModule,
    // components
    HeaderComponent,
    LayoutComponent,
    DataGridComponent,
    DataGridSkeletonComponent,
    SimpleSkeletonComponent,
    FormFieldComponent,
    BaseButtonComponent,
    ButtonListComponent,
    ButtonListGuardarComponent,
    DataGridButtonsComponent,
    ButtonBuscarComponent,
    ButtonLimpiarComponent,
    ButtonNuevoComponent,
    ButtonCancelarComponent,
    ButtonGuardarComponent,
    ButtonSelectComponent,
    DataGridEditableComponent,
    AlertComponent,
    ZippyComponent,
    ModalContainerComponent,
    ModalFormContainerComponent,
    DataGridFormFilterComponent,
    TreePickerComponent,
    PageTitleComponent,
    TopProgressbarComponent,
    DragDropSingleUploaderComponent,
    LoaderConfigurationComponent,
    TreePickerSingleComponent,
    SignalIconComponent,
    ListGridComponent,
    BandejaListGridComponent,
    UserProfileComponent,
    LoaderBlockUiComponent,
    ButtonExportarComponent,
    AlertBoxComponent,
    ImgOptionLinkComponent,
    ModalMsgErrorsComponent,
    ContainerRightItemsComponent,
    DataGridBodyColumnComponent,
    DataGridV2Component,
    DataGridV2BodyColumnComponent,
    DataGridButtonsEditableComponent,
    DataGridV2HeadColumnComponent,
    FormModelFieldComponent,
    ButtonExpandableComponent,
    // ContainerOptionLinkComponent,
    UploadFileComponent,
    UploadArchivoComponent,
    // directives
    SiuTemplateDirective,
    NgSelectFormFieldControlDirective,
    DisableControlDirective,
    NumberOnlyDirective,
    AlphanumericDirective,
    CustomAlphaNumericDirective,
    CustomNumericDirective,
    CustomNumericAlphaDirective,
    // pipes
    DateFormatPipe,
    BytesFormatPipe,
    TextLimitPipe,
    UploadArchivoZipComponent,
    MatStepperModule,
    MatFormFieldModule,
  ],
  entryComponents: [AlertComponent],
  providers: [DialogService, StatusCargaMasivaService],
})
export class SharedModule { }
